import React, { useEffect } from 'react';
import { t } from 'ttag';
import { CyberSecurityData } from '../..';
import sfx from '../../../../../services/sounds';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import { DialogueData } from '../../../../general/Dialogue';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import Squid from '../../characters/Squid';

const SquidIntro: React.FC<ISlide<CyberSecurityData>> = ({ defaultHeader, nextSlide, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    useEffect(() => {
        data.playMusic(sfx.themeCybersecurityOcto);
    }, []);

    const dialogue: DialogueData[] = [
        {
            character: Squid,
            text: t`Hi, I'm Octo. I may have a lot of arms but my email is still chockablock! Can you help me sort out my inbox?`,
            textSpriteName: 'octo-1-1',
            buttonText: t`Next`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default SquidIntro;
